import { render, staticRenderFns } from "./createLive.vue?vue&type=template&id=513093de&scoped=true"
import script from "./createLive.vue?vue&type=script&lang=js"
export * from "./createLive.vue?vue&type=script&lang=js"
import style0 from "./createLive.vue?vue&type=style&index=0&id=513093de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513093de",
  null
  
)

export default component.exports